/* bubba canada -- announcement bar auto-rotate (Horizon's autoplay attr is inert) */
(function () {
  if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
  if (document.getElementById('bb-cart-page')) return; // cart hides the header entirely
  setInterval(function () {
    var abc = document.querySelector('announcement-bar-component');
    if (!abc || abc.matches(':hover')) return;
    var next = abc.querySelector('slideshow-arrows button[aria-label="Next slide"]');
    // ph-no-capture: the auto-rotate fires a synthetic click every 5s; without
    // this class PostHog autocapture records each one (noise + quota burn)
    if (next) { next.classList.add('ph-no-capture'); next.click(); }
  }, 5000);
})();

/* colorway band: average product-image color at 40% alpha, like bubbabrands.com */
(function () {
  function avg(img, cb) {
    try {
      var c = document.createElement('canvas'); c.width = c.height = 48;
      var x = c.getContext('2d');
      // sample the centre 60% of the image: the studio photos have a light-grey
      // background sweep that passed the old all-channels>240 test and washed
      // the band to neutral; the product always sits centred
      var iw = img.naturalWidth || img.width, ih = img.naturalHeight || img.height;
      x.drawImage(img, iw * 0.2, ih * 0.2, iw * 0.6, ih * 0.6, 0, 0, 48, 48);
      var d = x.getImageData(0, 0, 48, 48).data, r = 0, g = 0, b = 0, n = 0;
      for (var i = 0; i < d.length; i += 4) {
        if (d[i+3] < 200) continue;
        if (d[i] > 240 && d[i+1] > 240 && d[i+2] > 240) continue;
        var mx = Math.max(d[i], d[i+1], d[i+2]), mn = Math.min(d[i], d[i+1], d[i+2]);
        if (mx - mn < 18 && mn > 185) continue; // light neutral = background, not colourway
        r += d[i]; g += d[i+1]; b += d[i+2]; n++;
      }
      if (n > 20) {
        // solid equivalent of the colorway at 40% over white, like bubba.com's band
        var sr = Math.round(r/n*0.28 + 255*0.72), sg = Math.round(g/n*0.28 + 255*0.72), sb = Math.round(b/n*0.28 + 255*0.72);
        cb('rgb(' + sr + ',' + sg + ',' + sb + ')');
      }
    } catch (e) {}
  }
  function paint(img, el, urlOverride) {
    if (!img && !urlOverride) return;
    var probe = new Image();
    probe.crossOrigin = 'anonymous';
    probe.onload = function () { avg(probe, function (col) { el.style.backgroundColor = col; }); };
    // currentSrc lags a freshly-assigned src by a microtask — callers swapping the
    // image must pass the new URL explicitly or the tint paints the OLD colourway
    probe.src = urlOverride || img.currentSrc || img.src;
  }
  function run() {
    var main = document.querySelector('.product-information');
    if (main) {
      var wrap = main.closest('.shopify-section') || main;
      var img = main.querySelector('img');
      var sel = 'slideshow-container, slideshow-slides, slideshow-slide, .product-media, .product-media__image';
      var paintAll = function () {
        var targets = [wrap, main].concat([...main.querySelectorAll(sel)]);
        if (window.__bbBand) {
          targets.forEach(function (t) { t.style.backgroundColor = window.__bbBand; });
        } else {
          var probe = new Image();
          probe.crossOrigin = 'anonymous';
          probe.onload = function () { avg(probe, function (col) {
            window.__bbBand = col;
            targets.forEach(function (t) { t.style.backgroundColor = col; });
          }); };
          probe.src = img.currentSrc || img.src;
        }
      };
      paintAll();
      new MutationObserver(function () { if (window.__bbBand) paintAll(); }).observe(main, {childList: true, subtree: true});
    }
    document.querySelectorAll('.bb-card').forEach(function (card) {
      if (card.hasAttribute('data-bg')) return; /* stored bubba.card_bg wins (homepage rail) */
      paint(card.querySelector('img'), card);
    });
  }
  window.__bbPaintCard = paint;
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', run); else run();
  window.addEventListener('load', run);
})();


/* collection cards: clicking a colourway dot swaps the card in place (like
   bubbabrands.com/shop) — image, tint, price, ring and link all follow, no navigation */
(function () {
  function select(dot) {
    var card = dot.closest('.bb-card');
    if (!card) return;
    var img = card.querySelector('img');
    if (img && dot.dataset.img) {
      img.removeAttribute('srcset');
      img.src = dot.dataset.img;
      if (window.__bbPaintCard) window.__bbPaintCard(img, card, dot.dataset.img);
    }
    if (dot.dataset.url) card.setAttribute('href', dot.dataset.url);
    var price = card.querySelector('.bb-price');
    if (price && dot.dataset.price) price.textContent = dot.dataset.price;
    card.querySelectorAll('.bb-swatch.is-active').forEach(function (s) { s.classList.remove('is-active'); });
    dot.classList.add('is-active');
  }
  document.addEventListener('click', function (e) {
    var dot = e.target.closest && e.target.closest('.bb-cswatches .bb-swatch');
    if (!dot) return;
    e.preventDefault();
    e.stopPropagation();
    select(dot);
  }, true);
  document.addEventListener('keydown', function (e) {
    if (e.key !== 'Enter' && e.key !== ' ') return;
    var dot = e.target.closest && e.target.closest('.bb-cswatches .bb-swatch');
    if (!dot) return;
    e.preventDefault();
    e.stopPropagation();
    select(dot);
  }, true);
})();


/* collection grids: in-stock products first (grid hydrates late, so retry + observe) */
(function () {
  var done = false;
  function demoteSoldOut() {
    var grid = document.querySelector('.product-grid');
    if (!grid || grid.children.length < 3) return;
    var items = [...grid.children];
    var outs = items.filter(function (it) { return /sold out/i.test(it.textContent); });
    if (!outs.length || done) return;
    outs.forEach(function (it) { grid.appendChild(it); });
    done = true;
  }
  ['DOMContentLoaded', 'load'].forEach(function (ev) { window.addEventListener(ev, demoteSoldOut); });
  [400, 900, 1800, 3000].forEach(function (t) { setTimeout(demoteSoldOut, t); });
})();


/* colorway swatches (product thumbnails in circles, like bubbabrands.com) + NEW badge */
(function () {
  function render() {
    var data = window.__BB_SWATCHES;
    if (!data) return;
    var main = document.querySelector('.product-information');
    if (!main) return;
    var m = location.pathname.match(/\/products\/([^/?#]+)/);
    if (!m) return;
    var handle = m[1];

    // NEW badge: only when the product carries the "new" tag
    var info = (data.meta || {})[handle];
    var h1 = main.querySelector('h1');
    if (info && info.n && h1 && !main.querySelector('.bb-new')) {
      var badge = document.createElement('span');
      badge.className = 'bb-new';
      badge.textContent = 'NEW';
      h1.parentElement.insertBefore(badge, h1);
    }

    if (main.querySelector('.bb-swatches')) return;
    var model = data.byHandle[handle];
    if (!model) return;
    var sibs = data.groups[model] || [];
    if (sibs.length < 2) return;
    var colorLine = [...main.querySelectorAll('p, div')].find(function (el) {
      return el.children.length <= 2 && /^COLOR:/i.test((el.textContent || '').trim());
    });
    if (!colorLine) return;
    var wrap = document.createElement('div');
    wrap.className = 'bb-swatches';
    sibs.forEach(function (s) {
      var a = document.createElement('a');
      a.className = 'bb-swatch' + (s.h === handle ? ' is-active' : '');
      a.href = '/products/' + s.h;
      a.style.backgroundImage = 'url(' + s.i + ')';
      a.title = s.c;
      a.setAttribute('aria-label', s.c);
      wrap.appendChild(a);
    });
    colorLine.insertAdjacentElement('afterend', wrap);
  }
  ['DOMContentLoaded', 'load'].forEach(function (e) { window.addEventListener(e, render); });
  [300, 900, 1800].forEach(function (t) { setTimeout(render, t); });
})();


/* gallery: put arrows on the same row as the dots, beneath the image (like bubbabrands.com) */
(function () {
  function place() {
    // desktop-only: the CSS that styles the combined row lives in a
    // min-width:901px block; below it Horizon's stock mobile gallery runs
    if (!window.matchMedia('(min-width: 901px)').matches) return;
    var controls = document.querySelector('.product-information slideshow-controls');
    var arrows = document.querySelector('.product-information slideshow-arrows');
    if (!controls || !arrows || controls.dataset.bbPlaced) return;
    var btns = arrows.querySelectorAll('button');
    if (btns.length < 2) return;
    controls.insertBefore(btns[0], controls.firstChild);
    controls.appendChild(btns[1]);
    arrows.remove();
    controls.dataset.bbPlaced = '1';
  }
  ['DOMContentLoaded', 'load'].forEach(function (e) { window.addEventListener(e, place); });
  [400, 1000, 2000].forEach(function (t) { setTimeout(place, t); });
})();

/* .com-style header search pill (desktop) — plain GET form, no Horizon deps */
(function () {
  function inject() {
    var ha = document.querySelector('header-actions');
    if (!ha || document.querySelector('.bb-search')) return;
    var f = document.createElement('form');
    f.action = '/search';
    f.method = 'get';
    f.className = 'bb-search';
    f.setAttribute('role', 'search');
    f.innerHTML =
      '<input type="search" name="q" placeholder="what are you looking for?" aria-label="search">' +
      '<button type="submit" aria-label="search"><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round"><circle cx="11" cy="11" r="7"></circle><path d="M20.5 20.5l-4.2-4.2"></path></svg></button>';
    ha.parentElement.insertBefore(f, ha);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', inject);
  else inject();
})();

/* cart drawer: .com-style free-shipping meter + green "Added to cart" check */
(function () {
  var THRESHOLD = 3500;
  var lastAdd = 0;
  document.addEventListener('click', function (e) {
    if (e.target.closest && e.target.closest('.add-to-cart-button, product-form-component button[type="submit"]')) {
      lastAdd = Date.now();
    }
  }, true);

  function money(cents) { return '$' + (cents / 100).toFixed(2); }

  /* the original title children (incl. any aria-labelledby target) are wrapped,
     hidden and restored -- never destroyed */
  function setTitle(title, added) {
    var orig = title.querySelector('.bb-title-orig');
    if (!orig) {
      orig = document.createElement('span');
      orig.className = 'bb-title-orig';
      while (title.firstChild) orig.appendChild(title.firstChild);
      title.appendChild(orig);
      var chk = document.createElement('span');
      chk.className = 'bb-added-check';
      chk.hidden = true;
      chk.innerHTML = '<svg viewBox="0 0 24 24" aria-hidden="true"><circle cx="12" cy="12" r="11" fill="#1D8A44"/><path d="M7 12.5l3.2 3.2L17 9" stroke="#fff" stroke-width="2.2" fill="none" stroke-linecap="round"/></svg>Added to cart';
      title.appendChild(chk);
    }
    var chk2 = title.querySelector('.bb-added-check');
    orig.hidden = !!added;
    chk2.hidden = !added;
  }

  function removeMeter(drawer) {
    var m = drawer.querySelector('.bb-dmeter');
    if (m) m.remove();
  }

  function render(cart) {
    var drawer = document.getElementById('cart-drawer');
    if (!drawer) return;
    var title = drawer.querySelector('.theme-drawer__title');
    if (!title) return;

    setTitle(title, Date.now() - lastAdd < 6000);

    /* the meter promises CAD rates -- match the cart page and stand down in
       any other presentment currency */
    if (cart.currency !== 'CAD') { removeMeter(drawer); return; }

    var meter = drawer.querySelector('.bb-dmeter');
    if (!meter) {
      meter = document.createElement('div');
      meter.className = 'bb-dmeter';
      meter.innerHTML = '<p class="bb-dmeter__msg"></p>' +
        '<div class="bb-dmeter__row"><span>$0.00</span>' +
        '<div class="bb-dmeter__track"><div class="bb-dmeter__fill"></div></div>' +
        '<span>' + money(THRESHOLD) + '</span></div>';
      title.insertAdjacentElement('afterend', meter);
    }
    // only touch the DOM when the total changed, or the observer loops forever
    if (meter.dataset.total === String(cart.total_price)) return;
    meter.dataset.total = String(cart.total_price);
    var remaining = THRESHOLD - cart.total_price;
    /* one bottle in the cart: any second bottle crosses $35 (cheapest is $17.99),
       so say that instead of "spend $X more" (Marcus, 2026-10-22). Only when a second
       unit still clears the bar after the 10% welcome code (unit >= $19.45): $17.99 and
       $18.99 bottles with BUBBA10 would land at $32-34 and still pay shipping. */
    meter.querySelector('.bb-dmeter__msg').innerHTML = remaining > 0
      ? (cart.item_count === 1 && cart.total_price * 2 * 0.9 >= THRESHOLD
          ? 'Add a second one and <strong>both ship free</strong>'
          : 'Spend <strong>' + money(remaining) + '</strong> more for free shipping')
      : 'You\'ve unlocked <strong>FREE shipping</strong>';
    meter.querySelector('.bb-dmeter__fill').style.width = Math.min(100, (cart.total_price / THRESHOLD) * 100) + '%';
  }

  var pending = null;
  function refresh() {
    clearTimeout(pending);
    pending = setTimeout(function () {
      var root = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
      fetch(root + 'cart.js')
        .then(function (r) { return r.json(); })
        .then(render)
        .catch(function () {});
    }, 250);
  }

  function attach() {
    var drawer = document.getElementById('cart-drawer');
    if (!drawer) return false;
    new MutationObserver(refresh).observe(drawer, { childList: true, subtree: true, attributes: true, attributeFilter: ['open'] });
    refresh();
    return true;
  }
  function init() {
    if (!attach()) {
      // drawer not in the DOM yet (e.g. deferred render) -- wait for it
      var bodyObs = new MutationObserver(function () { if (attach()) bodyObs.disconnect(); });
      bodyObs.observe(document.body, { childList: true, subtree: true });
    }
    document.addEventListener('cart:update', refresh);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();

/* .com-style hover dropdowns on the header nav (grape tab + white card) */
(function () {
  var MENUS = {
    'support & faqs': [
      ['order support', '/pages/support-faqs#order-support'],
      ['product faqs', '/pages/support-faqs#product-faqs'],
      ['use & care guide', '/pages/support-faqs#use-care']
    ]
  };
  /* shop opens a .com-style mega panel: five category cards + shop all */
  var MEGA = {
    cards: [
      { img: 'bubba-tile1.jpg', label: 'bottles', tag: 'bold hydration for every fit.', url: '/collections/bottles' },
      { img: 'bubba-tile2.jpg', label: 'tumblers', tag: 'sip or straw, your way.', url: '/collections/tumblers' },
      { img: 'bubba-tile4.jpg', label: 'jugs', tag: 'handle-ready, all-day fuel.', url: '/collections/jugs' },
      { img: 'bubba-tile5.jpg', label: 'mugs', tag: 'cozy sips, all-day comfort.', url: '/collections/mugs' }
    ],
    allLabel: 'shop all', allUrl: '/collections/all'
  };
  function assetUrl(name) {
    var stem = name.split('.')[0];
    var domImg = document.querySelector('img[src*="' + stem + '"]');
    if (domImg) return domImg.currentSrc || domImg.src;
    var probe = document.querySelector('link[href*="bubba.css"], script[src*="bubba.js"]');
    var base = probe ? (probe.href || probe.src) : '';
    return base.replace(/[^\/]*(\?.*)?$/, '') + name;
  }
  function buildMega() {
    var panel = document.createElement('div');
    panel.className = 'bb-dd bb-dd--mega';
    var row = document.createElement('div');
    row.className = 'bb-mega__row';
    MEGA.cards.forEach(function (c) {
      var a = document.createElement('a');
      a.className = 'bb-mega__card';
      a.href = c.url;
      a.innerHTML = '<img src="' + assetUrl(c.img) + '" alt="" loading="lazy">' +
        '<span class="bb-mega__label">' + c.label + '</span>' +
        '<span class="bb-mega__tag">' + c.tag + '</span>' +
        '<span class="bb-mega__cta">shop now &rsaquo;</span>';
      row.appendChild(a);
    });
    panel.appendChild(row);
    var all = document.createElement('a');
    all.className = 'bb-mega__all';
    all.href = MEGA.allUrl;
    all.innerHTML = MEGA.allLabel + ' &rsaquo;';
    panel.appendChild(all);
    return panel;
  }
  function init() {
    document.querySelectorAll('#header-group li.menu-list__list-item').forEach(function (li) {
      if (li.dataset.bbDd) return;
      var a = li.querySelector('a');
      if (!a) return;
      var key = a.textContent.trim().toLowerCase();
      var links = MENUS[key];
      var isMega = key === 'shop';
      if (!links && !isMega) return;
      if (isMega && document.getElementById('bb-cart-page')) return;
      // JS expando: Horizon's hydration morph strips unknown data-attributes
      // ~510ms in, which un-guarded the [500,1500] retries and double-mounted
      if (li.__bbDd) return;
      li.__bbDd = 1;
      li.classList.add('bb-has-dd');
      var panel;
      if (isMega) {
        document.querySelectorAll('.bb-dd--mega').forEach(function (old) { old.remove(); });
        panel = buildMega();
        // body-mounted: fixed positioning inside the header is trapped by
        // transformed/contained ancestors
        document.body.appendChild(panel);
      } else {
        panel = document.createElement('div');
        panel.className = 'bb-dd';
        links.forEach(function (l) {
          var x = document.createElement('a');
          x.href = l[1];
          x.textContent = l[0];
          panel.appendChild(x);
        });
        li.appendChild(panel);
      }
      a.setAttribute('aria-haspopup', 'true');
      a.setAttribute('aria-expanded', 'false');
      var t;
      function show() {
        clearTimeout(t);
        if (panel.classList.contains('bb-dd--mega')) {
          var row = li.closest('.header__row') || li;
          panel.style.top = Math.round(row.getBoundingClientRect().bottom) + 'px';
        }
        li.classList.add('bb-dd-open');
        panel.classList.add('bb-dd-open');
        a.setAttribute('aria-expanded', 'true');
      }
      function hide() {
        clearTimeout(t);
        t = setTimeout(function () { li.classList.remove('bb-dd-open'); panel.classList.remove('bb-dd-open'); a.setAttribute('aria-expanded', 'false'); }, 120);
      }
      [li, panel].forEach(function (el) {
        el.addEventListener('mouseenter', show);
        el.addEventListener('mouseleave', hide);
        el.addEventListener('focusin', show);
        el.addEventListener('focusout', hide);
      });
      document.addEventListener('keydown', function (e) { if (e.key === 'Escape') hide(); });
      if (isMega) {
        var closeOnScroll = function () { if (li.classList.contains('bb-dd-open')) hide(); };
        // >=990px Horizon scrolls .page-wrapper, not the window (element scroll
        // events don't bubble) -- bind both
        [window, document.querySelector('.page-wrapper')].forEach(function (sc) {
          if (sc) sc.addEventListener('scroll', closeOnScroll, { passive: true });
        });
        panel.addEventListener('wheel', closeOnScroll, { passive: true });
        // keyboard: Tab from the shop link enters the panel (it is body's last
        // child, unreachable in natural tab order)
        a.addEventListener('keydown', function (e) {
          if (e.key === 'Tab' && !e.shiftKey && li.classList.contains('bb-dd-open')) {
            e.preventDefault();
            var first = panel.querySelector('a');
            if (first) first.focus();
          }
        });
        panel.addEventListener('keydown', function (e) {
          if (e.key === 'Tab' && e.shiftKey && document.activeElement === panel.querySelector('a')) {
            e.preventDefault();
            a.focus();
          }
        });
      }
      document.addEventListener('pointerdown', function (e) {
        if (!li.contains(e.target) && !panel.contains(e.target)) hide();
      });
    });
  }
  ['DOMContentLoaded', 'load'].forEach(function (e) { window.addEventListener(e, init); });
  [500, 1500].forEach(function (t) { setTimeout(init, t); });
})();


/* PDP demo videos: autoplay muted on loop while the customer is on the page
   (Marcus 08-26). Horizon defers gallery video and creates the <video> lazily;
   on mobile Safari the first swipe onto the slide could land before the video
   had data, and the initial play() went nowhere until a second visit. Belt and
   braces: arm on creation (MutationObserver), replay on visibility
   (IntersectionObserver), retry when data arrives (canplay), and a light
   watchdog that nudges any paused on-screen video. iOS Low Power Mode still
   blocks autoplay; nothing can override that. */
(function () {
  var mg = document.querySelector('media-gallery');
  if (!mg) return;
  function visible(v) {
    var r = v.getBoundingClientRect();
    return r.width > 0 && r.bottom > 0 && r.top < innerHeight && r.right > 0 && r.left < innerWidth;
  }
  function tryPlay(v) {
    if (!v.paused) return;
    var p = v.play(); if (p && p.catch) p.catch(function () {});
  }
  function armVideo(v) {
    if (v.dataset.bbArmed) return;
    v.dataset.bbArmed = '1';
    // letterbox stays transparent: the colourway band paints the slide behind
    // it, so the box always matches this product's tinted background
    v.style.background = 'transparent';
    v.muted = true;
    ['muted', 'autoplay', 'loop', 'playsinline'].forEach(function (a) { v.setAttribute(a, ''); });
    v.removeAttribute('controls');
    v.setAttribute('preload', 'auto');
    ['loadeddata', 'canplay'].forEach(function (ev) {
      v.addEventListener(ev, function () { if (visible(v)) tryPlay(v); });
    });
    v.load();
    tryPlay(v);
    if ('IntersectionObserver' in window) {
      new IntersectionObserver(function (es) {
        es.forEach(function (e) { if (e.isIntersecting) tryPlay(e.target); });
      }, { threshold: 0.1 }).observe(v);
    }
  }
  function sweep() {
    mg.querySelectorAll('deferred-media').forEach(function (d) {
      if (!d.querySelector('video')) { var b = d.querySelector('button'); if (b) b.click(); }
    });
    mg.querySelectorAll('video').forEach(armVideo);
  }
  sweep();
  new MutationObserver(sweep).observe(mg, { childList: true, subtree: true });
  [1000, 3000].forEach(function (t) { setTimeout(sweep, t); });
  // watchdog: any armed, paused, on-screen video gets a nudge (first swipe included)
  setInterval(function () {
    if (document.hidden) return;
    mg.querySelectorAll('video[data-bb-armed]').forEach(function (v) {
      if (v.paused && visible(v)) tryPlay(v);
    });
  }, 700);
})();

// story-page film: same arming recipe as PDP videos (iOS needs attributes +
// an explicit load/play nudge; preload=metadata alone never paints a frame)
(function () {
  var v = document.querySelector('.bb-story__film');
  if (!v) return;
  v.muted = true;
  ['muted', 'autoplay', 'loop', 'playsinline'].forEach(function (a) { v.setAttribute(a, ''); });
  v.setAttribute('preload', 'auto');
  function go() { if (v.paused) { var p = v.play(); if (p && p.catch) p.catch(function () {}); } }
  ['loadeddata', 'canplay'].forEach(function (ev) { v.addEventListener(ev, go); });
  v.load();
  go();
  setInterval(function () { if (!document.hidden) go(); }, 700);
})();
